export * from "modules/IncompleteTyresDashboard/components/DeleteTyreModal";
export * from "modules/IncompleteTyresDashboard/components/EditTyreModal";
export * from "modules/IncompleteTyresDashboard/components/IncompleteTyresTable";
